import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  displayName: "CarePricestyles__Wrapper",
  componentId: "dq0by-0"
})(["margin-right:10px;min-width:50px;display:flex;flex-direction:column;align-items:flex-end;justify-content:center;"]);
export var Price = styled.div.withConfig({
  displayName: "CarePricestyles__Price",
  componentId: "dq0by-1"
})(["line-height:normal;font-weight:", ";"], function (props) {
  return props.theme.font.weight.bold;
});
export var SubPrice = styled.div.withConfig({
  displayName: "CarePricestyles__SubPrice",
  componentId: "dq0by-2"
})(["color:", ";font-size:", ";text-align:right;line-height:14px;margin-bottom:0;"], function (props) {
  return props.theme.color.monochrome.dark;
}, function (props) {
  return props.theme.font.size.caption;
});